import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { baseUrl } from "../../../constants";
import { apiClient } from "../../api";
import { TRANSACTIONS_API_RESPONSE, TRANSACTION_API_RESPONSE } from "./types";
import keys from "./keys";

/**
 * Transactions of the signed-in business. The server reads the businessId
 * from the business JWT, so it is never part of the URL.
 */
export const transactionsResourcePath = "business-transactions/me";

/** @param url full URL, usually `buildApiUrl(transactionsResourcePath)` */
export const useGetTransactions = (url: string) => {
  const {
    isLoading,
    data,
    isSuccess,
    error,
  }: UseQueryResult<TRANSACTIONS_API_RESPONSE, unknown> = useQuery(
    [keys.read, url],
    () => apiClient.get({ url }),
  );

  return { isLoading, data, isSuccess, error };
};

/** A single transaction; the server only returns it if it belongs to the caller's business. */
export const useGetTransaction = (id: string) => {
  const {
    isLoading,
    data,
    error,
  }: UseQueryResult<TRANSACTION_API_RESPONSE, unknown> = useQuery(
    [keys.read, id],
    () => apiClient.get({ url: `${baseUrl}/business-transactions/${id}` }),
    { enabled: !!id },
  );

  return { isLoading, data, error };
};
